import { useForm as useFormHook } from "hooks";
import useValidationSchema from "./useValidationSchema";
import {
    FormField,
    type OnboardingCompleteOnboaring,
    type OnboardingCompleteOnboaringForm
} from "./types";
import { BooleanSwitchValue } from "consts/general";

export const getInitialValues = <TApplication extends object>(
    initialValues: Partial<OnboardingCompleteOnboaring<TApplication>>
) => ({
    [FormField.HasAgreedTermsConditions]: BooleanSwitchValue.Off,
    ...initialValues
}) as OnboardingCompleteOnboaring<TApplication>;

export const useForm = <TApplication extends object>(onboardingCompleteOnbarding: OnboardingCompleteOnboaringForm<TApplication>) =>
    useFormHook({
        isInitialValid: false,
        validateOnMount: true,
        ...onboardingCompleteOnbarding,
        validationSchema: useValidationSchema()
    });
